<form class="form w-100" novalidate="novalidate" [formGroup]="resetPasswordForm" (ngSubmit)="submit()"
  id="kt_login_confirm_registration_form">
  <!--begin::Heading-->
  <div class="text-center mb-10">
    <!--begin::Title-->
    <h1 class="text-dark fw-bolder mb-3">
      Reset Password
    </h1>
    <!--end::Title-->

    <!--begin::Link-->
    <div class="text-gray-500 fw-semibold fs-6">
      Fill in the following details to complete your reset account password
    </div>
    <!--end::Link-->
  </div>
  <!--begin::Heading-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">Password</label>
    <input class="form-control bg-transparent" type="password" placeholder="Password" name="password"
      formControlName="password" autocomplete="off" [ngClass]="{
        'is-invalid': resetPasswordForm.controls['password'].value.length > 0 && resetPasswordForm.controls['password'].invalid,
        'is-valid': resetPasswordForm.controls['password'].value.length > 0 && resetPasswordForm.controls['password'].valid
      }" />

    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: resetPasswordForm.controls['password']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 8 symbols',
        control: resetPasswordForm.controls['password']
      }"></ng-container>

    <ng-container  [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'pattern',
        message: 'Passsword should have at least: 1 uppercase letter, 1 digit and 1 special character',
        control: resetPasswordForm.controls['password']
      }"></ng-container>

  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">Confirm Password</label>
    <input class="form-control bg-transparent" type="password" placeholder="Confirm password" name="cPassword"
      autocomplete="off" formControlName="cPassword" [pattern]="strongPasswordRegex" [ngClass]="{
        'is-invalid': resetPasswordForm.controls['cPassword'].value.length > 0 && resetPasswordForm.controls['cPassword'].invalid,
        'is-valid': resetPasswordForm.controls['cPassword'].value.length > 0 && resetPasswordForm.controls['cPassword'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Confirm Password is required',
        control: resetPasswordForm.controls['cPassword']
      }"></ng-container>

    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'pattern',
        message: 'Passsword should have at least: 1 uppercase letter, 1 digit and 1 special character',
        control: resetPasswordForm.controls['cPassword']
      }"></ng-container>

    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Confirm Password should have at least 3 symbols',
        control: resetPasswordForm.controls['cPassword']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Confirm Password should have maximum 100 symbols',
        control: resetPasswordForm.controls['cPassword']
      }"></ng-container>

    <ng-container *ngIf="
        resetPasswordForm.controls['cPassword'].errors &&
        resetPasswordForm.controls['cPassword'].errors.ConfirmPassword
      ">
      <div class="fv-plugins-message-container">
        <div class="fv-help-block">
          'Passsword' and 'Confirm Password' didn't match.
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="passwordReseted">
    <div class="mb-lg-15 alert alert-success">
      <!--begin::Body-->
      <div class="alert-text">Setup complete. Return to the <a routerLink="/auth/login">login page</a>.</div>
      <!--end::Body-->
    </div>
  </ng-container>

  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <!--begin::Body-->
      <div class="alert-text">Something went wrong.</div>
      <!--end::Body-->
    </div>
  </ng-container>
  <!--end::Form group-->
  <!--begin::Form group-->
  <div class="d-flex flex-wrap justify-content-center pb-lg-0">
    <button type="submit" id="kt_password_reset_submit" class="btn btn-primary me-4">
      <span class="indicator-label">Submit</span>
      <ng-container *ngIf="isLoading">
        <span class="indicator-progress">
          Please wait...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
    </button>
    <a routerLink="/auth/login" id="kt_login_confirm_registration_form_cancel_button" class="btn btn-light">
      Cancel
    </a>
  </div>
  <!--end::Form group-->
</form>
<!--end::Form-->

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  <ng-container *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block text-danger">
        <span role="alert">{{ message }}</span>
      </div>
    </div>
  </ng-container>
</ng-template>
